"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.viewportSchema = exports.IrbContentRenderingType = exports.IrbContentType = exports.PackagePartStatus = exports.IrbErrorCode = exports.IrbStatus = void 0;
const zod_1 = require("zod");
var IrbStatus;
(function (IrbStatus) {
    IrbStatus["ENQUEUED"] = "enqueued";
    IrbStatus["PROCESSING"] = "processing";
    IrbStatus["SUCCESS"] = "success";
    IrbStatus["FAILURE"] = "failure";
})(IrbStatus || (exports.IrbStatus = IrbStatus = {}));
var IrbErrorCode;
(function (IrbErrorCode) {
    IrbErrorCode["TRANSLATION_NOT_ENABLED"] = "irb.translation_not_enabled";
    IrbErrorCode["TRANSLATION_NOT_ENABLED_EN_US"] = "irb.translation_not_enabled_en_us";
})(IrbErrorCode || (exports.IrbErrorCode = IrbErrorCode = {}));
var PackagePartStatus;
(function (PackagePartStatus) {
    PackagePartStatus["PROCESSING"] = "processing";
    PackagePartStatus["SUCCESS"] = "success";
    PackagePartStatus["FAILURE"] = "failure";
})(PackagePartStatus || (exports.PackagePartStatus = PackagePartStatus = {}));
var IrbContentType;
(function (IrbContentType) {
    // Sign Up
    IrbContentType["SIGN_UP_STUDY_CODE"] = "SIGN_UP_STUDY_CODE";
    IrbContentType["SIGN_UP_INVITE_CODE"] = "SIGN_UP_INVITE_CODE";
    IrbContentType["SIGN_UP_RESEND_INVITE_CODE"] = "SIGN_UP_RESEND_INVITE_CODE";
    IrbContentType["SIGN_UP_CONTACT_SUPPORT"] = "SIGN_UP_CONTACT_SUPPORT";
    // Sign In
    IrbContentType["SIGN_IN_USERNAME_PW"] = "SIGN_IN_USERNAME_PW";
    IrbContentType["SIGN_IN_USERNAME_PW_ERROR"] = "SIGN_IN_USERNAME_PW_ERROR";
    IrbContentType["SIGN_IN_EMAIL_PW"] = "SIGN_IN_EMAIL_PW";
    IrbContentType["SIGN_IN_EMAIL_PW_UN_PW_ERROR_DIALOG"] = "SIGN_IN_EMAIL_PW_UN_PW_ERROR_DIALOG";
    IrbContentType["SIGN_IN_EMAIL_PW_ERROR_DIALOG"] = "SIGN_IN_EMAIL_PW_ERROR_DIALOG";
    IrbContentType["SIGN_IN_USERNAME_PW_ERROR_DIALOG"] = "SIGN_IN_USERNAME_PW_ERROR_DIALOG";
    IrbContentType["SIGN_IN_EMAIL_UN_PW"] = "SIGN_IN_EMAIL_UN_PW";
    IrbContentType["SIGN_IN_EMAIL_UN_PW_ERROR"] = "SIGN_IN_EMAIL_UN_PW_ERROR";
    IrbContentType["SIGN_IN_EMAIL_UN_PW_ERROR_DIALOG"] = "SIGN_IN_EMAIL_UN_PW_ERROR_DIALOG";
    IrbContentType["SIGN_IN_EMAIL_PW_ERROR"] = "SIGN_IN_EMAIL_PW_ERROR";
    IrbContentType["SIGN_IN_RESET_PASSWORD"] = "SIGN_IN_RESET_PASSWORD";
    IrbContentType["SIGN_IN_CONTACT_SUPPORT"] = "SIGN_IN_CONTACT_SUPPORT";
    // Authentication
    IrbContentType["AUTHENTICATION_UN_PW"] = "AUTHENTICATION_UN_PW";
    IrbContentType["AUTHENTICATION_EMAIL_PW"] = "AUTHENTICATION_EMAIL_PW";
    IrbContentType["AUTHENTICATION_EMAIL_PW_NAME"] = "AUTHENTICATION_EMAIL_PW_NAME";
    IrbContentType["AUTHENTICATION_EMAIL_PW_PHONE"] = "AUTHENTICATION_EMAIL_PW_PHONE";
    IrbContentType["AUTHENTICATION_EMAIL_PW_NAME_PHONE"] = "AUTHENTICATION_EMAIL_PW_NAME_PHONE";
    IrbContentType["AUTHENTICATION_INLINE_VALIDATION_ERRORS"] = "AUTHENTICATION_INLINE_VALIDATION_ERRORS";
    IrbContentType["AUTHENTICATION_LIST_ALL_INLINE_VALIDATION_VALUES"] = "AUTHENTICATION_LIST_ALL_INLINE_VALIDATION_VALUES";
    IrbContentType["AUTHENTICATION_DIALOG_ERRORS"] = "AUTHENTICATION_DIALOG_ERRORS";
    IrbContentType["AUTHENTICATION_LIST_ALL_DIALOG_VALIDATION_VALUES"] = "AUTHENTICATION_LIST_ALL_DIALOG_VALIDATION_VALUES";
    // Schedule
    IrbContentType["SCHEDULE_FIRST_TIME_USER_NAVIGATES"] = "SCHEDULE_FIRST_TIME_USER_NAVIGATES";
    // Visit Names
    IrbContentType["VISIT_NAMES"] = "VISIT_NAMES";
    IrbContentType["SCHEDULE_LIST_ALL_ACTIVITY_NAMES"] = "SCHEDULE_LIST_ALL_ACTIVITY_NAMES";
    // Activities
    IrbContentType["ACTIVITIES"] = "ACTIVITIES";
    IrbContentType["ACTIVITIES_APPENDIX"] = "ACTIVITIES_APPENDIX";
    // Activities Validation
    IrbContentType["ACTIVITIES_VALIDATION_NDE"] = "ACTIVITIES_VALIDATION_NDE";
    IrbContentType["ACTIVITIES_VALIDATION_DATE_TIME"] = "ACTIVITIES_VALIDATION_DATE_TIME";
    IrbContentType["ACTIVITIES_VALIDATION_TEXT_INPUTS"] = "ACTIVITIES_VALIDATION_TEXT_INPUTS";
    // Activities Modals
    IrbContentType["ACTIVITIES_MODALS_SKIP"] = "ACTIVITIES_MODALS_SKIP";
    IrbContentType["ACTIVITIES_MODALS_CANCEL"] = "ACTIVITIES_MODALS_CANCEL";
    IrbContentType["ACTIVITIES_MODALS_SPECIFIC_DIALOG"] = "ACTIVITIES_MODALS_SPECIFIC_DIALOG";
    // Resources
    IrbContentType["RESOURCES_LIST"] = "RESOURCES_LIST";
    IrbContentType["RESOURCES_LIST_ALL"] = "RESOURCES_LIST_ALL";
    IrbContentType["RESOURCES_URL"] = "RESOURCES_URL";
    IrbContentType["RESOURCES_PDF"] = "RESOURCES_PDF";
    IrbContentType["RESOURCES_RICH_TEXT"] = "RESOURCES_RICH_TEXT";
    // Notifications
    IrbContentType["NOTIFICATION_SMS"] = "NOTIFICATION_SMS";
    IrbContentType["NOTIFICATION_PUSH_NOTIFICATION"] = "NOTIFICATION_PUSH_NOTIFICATION";
    IrbContentType["NOTIFICATION_EMAIL"] = "NOTIFICATION_EMAIL";
    IrbContentType["NOTIFICATIONS_STANDARD"] = "NOTIFICATIONS_STANDARD";
    IrbContentType["NOTIFICATIONS_STANDARD_SIGN_IN"] = "NOTIFICATIONS_STANDARD_SIGN_IN";
    IrbContentType["NOTIFICATIONS_STANDARD_TELEVISIT"] = "NOTIFICATIONS_STANDARD_TELEVISIT";
    IrbContentType["NOTIFICATIONS_STANDARD_CONSENT"] = "NOTIFICATIONS_STANDARD_CONSENT";
    // Participant App
    IrbContentType["PARTICIPANT_APP_SETTINGS"] = "PARTICIPANT_APP_SETTINGS";
    IrbContentType["PARTICIPANT_APP_PROFILE_SWITCHER"] = "PARTICIPANT_APP_PROFILE_SWITCHER";
    // Televisit
    IrbContentType["TELEVISIT_SCHEDULE_VIEW"] = "TELEVISIT_SCHEDULE_VIEW";
    IrbContentType["TELEVISIT_WAITING_ROOM"] = "TELEVISIT_WAITING_ROOM";
    IrbContentType["TELEVISIT_READY_TO_START"] = "TELEVISIT_READY_TO_START";
    IrbContentType["TELEVISIT_SETTINGS"] = "TELEVISIT_SETTINGS";
    IrbContentType["TELEVISIT_CALL_IN_PROGRESS"] = "TELEVISIT_CALL_IN_PROGRESS";
    // eConsent
    IrbContentType["ECONSENT_INTRODUCTION_PAGE"] = "ECONSENT_INTRODUCTION_PAGE";
    IrbContentType["ECONSENT_DOCUMENT_FIELD_TYPES"] = "ECONSENT_DOCUMENT_FIELD_TYPES";
    IrbContentType["ECONSENT_MODAL_PARTICIPANT_SIGNATURE"] = "ECONSENT_MODAL_PARTICIPANT_SIGNATURE";
    IrbContentType["ECONSENT_MODAL_PARTICIPANT_SIGNATURE_PASSWORD_ERROR"] = "ECONSENT_MODAL_PARTICIPANT_SIGNATURE_PASSWORD_ERROR";
    IrbContentType["ECONSENT_MODAL_PARTICIPANT_SIGNATURE_AUTH_ERROR"] = "ECONSENT_MODAL_PARTICIPANT_SIGNATURE_AUTH_ERROR";
    IrbContentType["ECONSENT_SIGNATURE_SUCCESS_IN_DOC"] = "ECONSENT_SIGNATURE_SUCCESS_IN_DOC";
    IrbContentType["ECONSENT_COMPLETION_SCREEN"] = "ECONSENT_COMPLETION_SCREEN";
    IrbContentType["ECONSENT_SCHEDULE_PENDING_SIGNATURES"] = "ECONSENT_SCHEDULE_PENDING_SIGNATURES";
})(IrbContentType || (exports.IrbContentType = IrbContentType = {}));
var IrbContentRenderingType;
(function (IrbContentRenderingType) {
    IrbContentRenderingType["SCREENSHOTS"] = "screenshots";
    IrbContentRenderingType["LIST"] = "list";
    IrbContentRenderingType["NOTIFICATION_PUSH_NOTIFICATION"] = "notification_push_notification";
    IrbContentRenderingType["NOTIFICATION_SMS"] = "notification_sms";
    IrbContentRenderingType["NOTIFICATION_EMAIL"] = "notification_email";
})(IrbContentRenderingType || (exports.IrbContentRenderingType = IrbContentRenderingType = {}));
exports.viewportSchema = zod_1.z.object({
    width: zod_1.z.number().positive(),
    height: zod_1.z.number().positive(),
    scale: zod_1.z.number().positive(),
});
//# sourceMappingURL=types.js.map